import { render, staticRenderFns } from "./SpecialTokuyama.vue?vue&type=template&id=995f165e"
import script from "./SpecialTokuyama.vue?vue&type=script&lang=js"
export * from "./SpecialTokuyama.vue?vue&type=script&lang=js"
import style0 from "./SpecialTokuyama.vue?vue&type=style&index=0&id=995f165e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports